import { FlightLogsEvent } from '../common/api/spidertracks-sdk/types/FlightLogs';
import {
  ActiveDeviceConnection,
  PrivateTrackData
} from '../common/api/spidertracks-sdk/types/TrackData';

export enum AircraftTypeEnum {
  FIXED_WING = 'FIXED_WING',
  ROTARY = 'ROTARY',
  OTHER = 'OTHER',
  UNDEFINED = 'UNDEFINED'
}

export interface Aircraft {
  registration: string;
  type: AircraftTypeEnum;
  isActive: boolean;
  trackStatus: string;
  aircraftIcon: string;
  aircraftIconColor: string;
}

export interface TrackUser {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  orgs: [];
}

export interface UIFlightLogs {
  eventId: string;
  eventName: string;
  eventDescription?: string;
  eventTime: number;
  durationMillis?: number;
  isBackfilled?: boolean;
}

export interface UILegacyEvent {
  eventName: string;
  eventDescription?: string;
  eventTime: number;
  durationMillis?: number;
}

export interface FlightDetail {
  aircraftId: string;
  aircraft: Aircraft;
  activeDeviceConnection?: ActiveDeviceConnection;
  track: PrivateTrackData;
}

export enum FlightStatusFilterEnum {
  NOW = 'NOW',
  TODAY = 'TODAY',
  LAST24H = 'LAST24H',
  LAST7D = 'LAST7D',
  ALL = 'ALL'
}

export interface FlyingPageFilters {
  filterText: string | undefined;
  status: FlightStatusFilterEnum;
  aircraftType: (AircraftTypeEnum | '*')[];
  organisationIds: string[];
}

export interface FlyingPageState {
  latestFlightDetails: FlightDetail[];
  filters: FlyingPageFilters;
  selectedFlightAircraftId: string | undefined;
  loading: boolean;
  flightlogsInitialLoad: boolean;
  showFiltersHideSearch: boolean;
  showAircraftListPanel: boolean;
  UIFlightLogs: {
    [key: string]: {
      startEvent: UIFlightLogs | undefined;
      endEvent: UIFlightLogs | undefined;
      takeoffAndLandingEvents: UIFlightLogs[];
    };
  };
  UILegacyEvents: {
    [key: string]: {
      startEvent: UILegacyEvent;
      endEvent: UILegacyEvent;
      speedUpOrDownEvents: UILegacyEvent[];
    };
  };
}
